import React from 'react';
import './InfoTag.css';

const InfoTag = ({ headline, subtitle }) => {
  return (
    <div className="info-tag">
      <div className="info-tag-headline">{headline}</div>
      <div className="info-tag-subtitle">{subtitle}</div>
    </div>
  );
};

export default InfoTag; 